module.exports = __webpack_public_path__ + "static/media/1.8ab4b900.jpg";